import { isCurrentScopedIdentity, type DraftContext } from "@/features/coach-review/composerDrafts";

/** Ordinary viewer metadata uses the same coherent scope/logout generation. */
export async function ownedScopedRequest<T>(owner: DraftContext, request: () => Promise<T>): Promise<T> {
  const assertOwner = () => { if (!isCurrentScopedIdentity(owner)) throw new Error("Recording context changed"); };
  assertOwner();
  try { const result = await request(); assertOwner(); return result; }
  catch (error) { assertOwner(); throw error; }
}
